export const state = () => ({
    isMobile: false
});

export const getters = {
    isMobile: state => state.isMobile
};

export const mutations = {
    SET_IS_MOBILE(state, isMobile) {
        state.isMobile = isMobile;
    }
};

export const actions = {
    isMobile({ commit }) {
        let isMobile = false;
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            isMobile = true;
        } else {
            isMobile = false;
        }
        commit('SET_IS_MOBILE', isMobile);
    }
};
